<template>
  <div id="app">
     <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
     <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!-- 登录对话框  必须全局注册  控制显示隐藏在vuex中控制 -->
    <Login />
    <Loading v-show="LOADING" />
  </div>
</template>

<script>
import Login from "./components/login/login";
import Loading from "./views/common/loading";
export default {
  components: {
    Login,
    Loading,
  },
  created() {
    this.getCode();
    if ( this.GLOBAL.formal && window.location.href.indexOf("https://m.xzjy365.com")) {
      // 如果当前的地址内容不包含
      // window.location.href = "https://m.xzjy365.com"
      let str = window.location.href;
      let idx = str.indexOf("/");
      let count = 1;
      while (idx >= 0 && count < 3) {
        idx = str.indexOf("/", idx + 1);
        count++;
      }
      if (idx < 0) {
        return "";
      }
      let oldSrc = str.substring(0, idx);
      let newSrc = str.replace(oldSrc, "https://m.xzjy365.com");
      window.location.href = newSrc;
    }
    let token = localStorage.getItem("setToken"); // 如果本地的缓存魏undefined  清空本地的所有缓存
    let uid = localStorage.getItem("uid"); // 如果本地的缓存魏undefined  清空本地的所有缓存
    if (token == undefined || token == "undefined") {
      localStorage.clear();
    }
    if (uid == undefined || uid == "undefined" || uid == null || uid == "") {
      localStorage.clear();
    }
  },
  computed: {
    LOADING() {
      return this.$store.state.Login.loading;
    },
    APPCLIENT() {
      return this.$store.state.Login.appClient;
    },
  },
  watch: {
    APPCLIENT: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val == "JSAPI") {
          this.wxLogin();
        }
      },
    },
  },
  methods: {
    wxLogin() {
      let wxLogin = this.GLOBAL.wxLogin;
      window.location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        wxLogin.appid +
        "&redirect_uri=https://m.xzjy365.com&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
    },
    // 获取微信返回的code
    getCode() {
      if (
        this.$route.query.code == undefined &&
        this.$route.query.openId == undefined
      ) {
        // 如果微信的code和QQ的id都为空 返回
        return false;
      }
      if (this.$route.query.code != undefined) {
        this.wxLogin.code = this.$route.query.code;
        let data = {
          code: this.wxLogin.code,
          uid: localStorage.getItem("uid"),
        };
        this.Api({
          url: "api/getaccess_tokenBycode",
          method: "POST",
          data,
        })
          .then((res) => {
            this.$toast("微信授权登录");
            this.detectBind(res.data);
          })
          .catch((err) => {
            alert("失败微信登录,请联系学习规划老师");
            console.log(JSON.stringify(err));
          });
      } else if (this.$route.query.openId != undefined) {
        let data = {
          qqOpenid: this.$route.query.openId,
          accessToken: this.$route.query.accessToken,
          uid: localStorage.getItem("uid"),
        };
        this.Api({
          url: "api/qq/get_access_token",
          method: "POST",
          data,
        })
          .then((res) => {
            this.$toast("QQ授权登录成功");
            this.detectBind(res.data);
          })
          .catch((err) => {
            alert("QQ授权登录失败,请联系学习规划老师");
            console.log(JSON.stringify(err));
          });
      }
    },
    // 检测是否绑定了微信和QQ
    detectBind(data) {
      this.$store.commit("Login/editPersonalInfo", data);
      localStorage.setItem("uid", data.uid);
      if (data.qqOpenid != null) {
        this.$store.commit("Login/editQqBingType", true);
        localStorage.setItem("qqOpenidType", data.qqOpenid);
      }
      if (data.wxOpenid != null) {
        this.$store.commit("Login/editWxBingType", true);
        localStorage.setItem("wxOpenidType", data.wxOpenid);
      }
    },
  },
};
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
#app {
  width: 100%;
  height: 100%;
}
</style>
